import { WidgetComponent } from "../widget.component";
import { EditableWidget, WIDGET_ETHERPAD } from "@shared/models/widget";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FE_EtherpadWidget } from "@shared/models/integration";
import { SessionStorage } from "@shared/SessionStorage";
import { NameService } from "@shared/services/name.service";
import * as url from "url";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";
import { ConfigScreenWidgetComponent } from "../config-screen/config-screen.widget.component";
import { FieldComponent } from "../../../elements/field/field.component";

@Component({
    templateUrl: "etherpad.widget.component.html",
    styleUrls: ["etherpad.widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenWidgetComponent, FieldComponent, TranslatePipe]
})
export class EtherpadWidgetConfigComponent extends WidgetComponent {

    private readonly etherpadWidget: FE_EtherpadWidget = <FE_EtherpadWidget>SessionStorage.editIntegration;

    constructor(private readonly nameService: NameService, public translate: TranslateService, logService: LogService) {
        super(WIDGET_ETHERPAD, "Notes", translate, logService, "generic", "etherpad", "padName");
    }

    protected OnWidgetsDiscovered(widgets: EditableWidget[]): void {
        for (const widget of widgets) {
            if (!widget.dimension.newUrl.startsWith("http://") && !widget.dimension.newUrl.startsWith("https://")) {
                const parsedUrl = url.parse(widget.url, true);
                const padName = parsedUrl.query["padName"];

                // Set the new URL so that it unpacks correctly
                widget.url = `https://scalar.vector.im/etherpad/p/${padName}`;
            }
        }
    }

    protected OnNewWidgetPrepared(widget: EditableWidget): void {
        const name = this.nameService.getHumanReadableName();

        let template = "https://scalar.vector.im/etherpad/p/$roomId_$padName";
        if (this.etherpadWidget.options?.defaultUrl) {
            template = this.etherpadWidget.options.defaultUrl;
        }

        template = template.replace("$roomId", encodeURIComponent(SessionStorage.roomId).slice(0, 10));
        template = template.replace("$padName", encodeURIComponent(name));

        widget.dimension.newUrl = template;
        widget.dimension.newName = name;
    }
}
